import axios from "axios";
import { useEffect, useState } from "react";
import CustomPagination from "../../Utility/CustomPagination";

const PayoutsTable = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10;

  const fetchPayouts = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/host/get-payout-transactions?page=${currentPage}&per_page=${limit}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      setTransactions(Array.isArray(res?.data?.data) ? res.data.data : []);

      if (res.data.pagination) {
        setCurrentPage(res.data.pagination.current_page);
        setTotalPages(res.data.pagination.last_page);
      } else if (res.data.meta) {
        setCurrentPage(res.data.meta.current_page);
        setTotalPages(res.data.meta.last_page);
      }
    } catch (err) {
      console.error("Error fetching payouts:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayouts(currentPage);
  }, [currentPage]);

  const formatCurrency = (amount, currency = "USD") => {
    if (amount == null) return "—";

    // handle when API gives symbol instead of code
    const validCurrency = ["USD", "INR", "EUR", "AUD", "GBP", "CAD"];
    const currencySymbols = {
      USD: "$",
      INR: "₹",
      EUR: "€",
      AUD: "$",
      GBP: "£",
      CAD: "$",
    };

    // normalize currency input
    let code = currency?.toUpperCase() || "USD";
    if (!validCurrency.includes(code)) code = "USD";

    const symbol = currencySymbols[code] || "";

    // ensure proper number format and show symbol + amount + code
    const formattedAmount = parseFloat(amount).toFixed(2);
    return `${symbol} ${formattedAmount} ${code}`;
  };

  const formatDate = (dateStr) =>
    dateStr ? new Date(dateStr).toLocaleDateString("en-GB") : "—";

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  if (loading) return <p className="text-center py-4">Loading payouts…</p>;
  if (!transactions.length)
    return <p className="text-center py-4">No payouts found.</p>;

  return (
    <div className="table-responsive">
      <table className="table table-condensed table-striped tbl_algn_ar">
        <thead>
          <tr>
            <th>Payout ID</th>
            <th>Date</th>
            <th>Amount</th>
            <th>Payment Mode</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((tx) => {
            // map payment_mode for clarity
            let modeLabel = "";
            let modeColor = "";

            switch (tx.payment_mode) {
              case "1":
                modeLabel = "Bank Transfer";
                modeColor = "green";
                break;
              case "2":
                modeLabel = "Stripe";
                modeColor = "blue";
                break;
              default:
                modeLabel = "Unknown";
                modeColor = "gray";
            }

            return (
              <tr key={tx.id}>
                <td>{tx.transaction_id?.toUpperCase() || "—"}</td>
                <td>{formatDate(tx.updated_at)}</td>
                <td>{formatCurrency(tx.amount, tx.currency)}</td>
                <td style={{ color: modeColor, fontWeight: 600 }}>
                  {modeLabel}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <CustomPagination
        currentPage={currentPage}
        lastPage={totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default PayoutsTable;
